export const environment = {
    name: 'mtf',
    production: true,
    url: 'https://services.sendtestapp.mtf.moovetshop.com/',
    translationBucketUrl: 'https://moovet-acquirer.s3.amazonaws.com/moovetpay-acquirer/translation/mc_send_test_app/',
    translationBucketUrlFull: 'https://moovet-acquirer.s3.amazonaws.com/moovetpay-acquirer/translation/mc_send_test_app/en-US.json',
    googleSiteKey: '6LfweS4rAAAAAHSAxa0eAfRZ9FNK-emOV_NTt0LI',
};
